// 受付ステータスのトグル処理
export function CheckIcon({ checked }) {
  return (
    <span
      style={{
        fontWeight: "bold",
        width: "1em",
        display: "inline-block",
      }}
    >
      {checked ? "☑" : "☐"}
    </span>
  );
}